import { useState, useEffect } from 'react';
import { makeTr8 } from '../translations/tr8';

export const useTr8 = (locale: string) => {
  const [tr8, setTr8] = useState(() => makeTr8('en_US'));

  useEffect(() => {
    const _tr8 = makeTr8(locale);
    if (_tr8) {
      setTr8(() => _tr8);
    }
  }, [locale]);

  return tr8;
};
